import { FC } from 'react';
import InboxOutlined from 'assets/svg/InboxOutlined';
import ArrowRight from 'assets/svg/ArrowRight';

interface AlertsWidgetProps {
    title?: string;
    style?: React.CSSProperties;
    className?: string;
}

export const AlertsWidget: FC<AlertsWidgetProps> = ({
    title = 'Total Alerts',
    style,
    className = '',
}) => {
    return (
        <div
            className={`flex min-w-0 flex-1 flex-col gap-3 rounded-xl bg-backgroundGreyAlt p-4 ${className}`}
            style={style}
        >
            <div className="flex w-full shrink-0 items-center justify-between">
                <div className="flex items-center gap-2 rounded-md bg-white px-2 py-1">
                    <span className="h-2 w-2 shrink-0 rounded-full bg-[#ec343e] opacity-50" />
                    <span className="text-sm font-medium leading-5 text-black/25">
                        {title}
                    </span>
                </div>
                {/* <button
                    type="button"
                    disabled
                    className="flex h-8 items-center gap-2 rounded-md border-0 bg-transparent px-4 text-sm font-semibold text-black/25 transition-colors"
                >
                    View All
                    <ArrowRight color={'grey'} strokeWidth='2' className='opacity-50' />
                </button> */}
            </div>
            <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-2 px-8 py-6">
                <div className="mb-2 flex h-[61px] w-[96px] shrink-0 items-center justify-center">
                    <InboxOutlined customIndex={0} />
                </div>
                <div className="flex flex-col items-center gap-1 text-center">
                    <p className="m-0 text-base font-semibold leading-8 text-black/88">Coming Soon!</p>
                    <p className="m-0 text-base font-normal leading-[22px] text-black/45">Get critical alerts about your portfolio here.</p>
                </div>
            </div>
        </div>
    );
};

export default AlertsWidget;
